/** Wordmark: a small tile in the text color and the name in the display face. */
export function Logo(_props: { today?: string }) {
  return (
    <div className="logo">
      <svg width="20" height="20" viewBox="0 0 22 22" aria-hidden="true">
        <rect width="22" height="22" rx="6" fill="currentColor" />
        <rect x="5" y="6" width="12" height="2.4" rx="1.2" fill="var(--logo-ink)" />
        <rect x="5" y="10.3" width="7" height="2.4" rx="1.2" fill="var(--logo-ink)" opacity="0.6" />
        <circle cx="15" cy="15" r="2.3" fill="var(--link)" />
      </svg>
      <span>macro</span>
    </div>
  );
}
